import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dayjs from "dayjs";

export const fetchSummaryExcel = createAsyncThunk("fetchSummaryExcel", async ({ filters }) => {
	const formatDate = (date) => (date && date.isValid && date.isValid() ? date.format("YYYY-MM-DD") : date ? dayjs(date).format("YYYY-MM-DD") : "");

	// Clean filters - only include non-empty values
	const cleanFilters = {};

	// Add search keyword if it exists and is not undefined/empty
	if (filters?.keyword && typeof filters.keyword === "string" && filters.keyword.trim() !== "") {
		cleanFilters.search = filters.keyword.trim();
	}

	// Add date range if it exists
	if (filters?.dateRange && filters.dateRange[0] && filters.dateRange[1]) {
		cleanFilters.startDate = formatDate(filters.dateRange[0]);
		cleanFilters.endDate = formatDate(filters.dateRange[1]);
	}

	// Add company ID if it exists and is not empty string or undefined/null
	if (filters?.company && String(filters.company).trim() !== "" && filters.company !== undefined && filters.company !== null) {
		cleanFilters.companyId = filters.company;
	}

	// Add department ID if it exists and is not empty string or undefined/null
	if (filters?.department && String(filters.department).trim() !== "" && filters.department !== undefined && filters.department !== null) {
		cleanFilters.departmentId = filters.department;
	}

	// Add value chain ID if it exists and is not empty string or undefined/null
	if (filters?.valueChain && String(filters.valueChain).trim() !== "" && filters.valueChain !== undefined && filters.valueChain !== null) {
		cleanFilters.valueChainId = filters.valueChain;
	}

	// Add sorting parameters (but not pagination for export)
	cleanFilters.sortBy = filters?.sortBy ?? "name";
	cleanFilters.sortOrder = filters?.sortOrder ?? "asc";

	const params = new URLSearchParams(cleanFilters);

	try {
		const response = await axiosHttp.get(`attendance/summary-excel?${params}`, {
			responseType: "blob",
		});

		// Create a Blob from the response
		const blob = new Blob([response.data], {
			type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		const url = window.URL.createObjectURL(blob);

		// Create a link and trigger the download
		const link = document.createElement("a");
		link.href = url;
		const currentDate = dayjs().format("YYYY-MM-DD");
		link.setAttribute("download", `attendance-summary-${currentDate}.xlsx`);
		document.body.appendChild(link);
		link.click();
		link.remove();

		// Clean up the URL object
		window.URL.revokeObjectURL(url);

		return { success: true };
	} catch (error) {
		throw error;
	}
});
const summaryExcelSlice = createSlice({
	name: "attendanceSummaryExcel",
	initialState: {
		data: null,
		isLoading: false,
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchSummaryExcel.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchSummaryExcel.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(fetchSummaryExcel.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload;
			});
	},
});
export default summaryExcelSlice.reducer;
